<onyx-modal
  variant="center"
  heading="{{ fleet | fleetIdentifier }} - {{ `${I18N}.heading` | translate }}"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <onyx-icon
    headingIcon
    [name]="`${fleet.generalInformation.category}-filled`"
    [size]="20"
  ></onyx-icon>

  <div class="container">
    <form [formGroup]="form" [onyxAutoFocus]="true">
      @let controls = form.controls;
      <onyx-dropdown
        data-testid="primary-driver-dropdown"
        [formControl]="controls.primaryDriverUuid"
        label="labels.primaryDriver"
        [link]="links().primaryDriver"
        [options]="DRIVERS_SOURCE"
        [optional]="true"
        (selectedOptionValueChange)="primaryDriver.set($event.value)"
      ></onyx-dropdown>

      <onyx-dropdown
        data-testid="secondary-driver-dropdown"
        [formControl]="controls.secondaryDriverUuid"
        label="labels.secondaryDriver"
        [link]="links().secondaryDriver"
        [options]="DRIVERS_SOURCE"
        [optional]="true"
        (selectedOptionValueChange)="secondaryDriver.set($event.value)"
      ></onyx-dropdown>
    </form>

    @for (swappedData of swappedData(); track swappedData.driver.uuid) {
      <onyx-message intent="warning">
        <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

        <p>
          @let driverData = swappedData.driver.driverData;
          @let vehicle = swappedData.vehicle;

          {{ 'labels.driver' | translate }}

          <span class="f-paragraph-s f-semibold">
            {{ driverData | onyxName }}
          </span>

          {{ `${I18N}.willBeUnassigned` | translate }}

          <span class="f-paragraph-s f-semibold">{{
            vehicle | fleetIdentifier
          }}</span>
        </p>
      </onyx-message>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button
      data-testid="cancel-button"
      variant="outlined"
      (click)="close$.next()"
    >
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      data-testid="save-button"
      [disabled]="form.invalid"
      [spinner]="loading()"
      (click)="!loading() ? submit() : null"
    >
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
